export default __webpack_public_path__ + "static/media/calendar.502b6a2f.svg";